const mobile = () => window.matchMedia("(max-width: 600px)").matches;

const [cx, cy] = ol.proj.fromLonLat([18.101194, 42.658037]);
const extent_buffer_x = 2e3;
const extent_buffer_y = .25e3;
const extent = [
    2009459.9380342084914446 - extent_buffer_x,
    5255702.9559586877003312 - extent_buffer_y,
    2020142.9846513059455901 + extent_buffer_x,
    5264143.3782859360799193 + extent_buffer_y,
];

const base_url = `${window.location.protocol}//${window.location.hostname}`;

const tile_url = base_url + '/api/tiles';
// const tile_url = base_url + ':5000/tiles';

const timeseries_url = base_url + '/api/timeseries';
// const timeseries_url = base_url + ':5000/timeseries';

const basemap_url = base_url + '/basemap';
// const basemap_url = 'http://localhost:5100/services/dof/tiles';

// const basemap_source = new ol.source.Stamen({
//     layer: 'watercolor',
// });

const basemap_source = new ol.source.XYZ({
    url: basemap_url + '/{z}/{x}/{y}.jpg',
    attributions: [
        'DOF 2019/2020 © Državna geodetska uprava RH, 2021.',
    ],
});

const basemap_layer = new ol.layer.Tile({source: basemap_source});

const basemap_labels_source = new ol.source.Stamen({
    layer: 'terrain-labels',
});

const basemap_labels_layer = new ol.layer.Tile({
    source: basemap_labels_source,
    maxZoom: 16,
});

const layer_styles = {
    LST: {
        colormap: 'jet',
        stretch_range: '[0, 40]',
    },
    NDVI: {
        colormap: 'spectral',
        stretch_range: '[0, 1]',
    },
    modeled: {
        // colormap: 'magma_r',
        // stretch_range: '[0, 250]',
        colormap: 'ylorrd',
        stretch_range: null,
    }
};

const get_style = async (layer_name, granularity, time) => {
    let style = layer_styles[layer_name];
    if (style === undefined) {
        style = Object.assign({}, layer_styles.modeled);
        let metadata = await fetch(
            `${tile_url}/metadata/${layer_name}/${granularity}/${time}`
        ).then(response => response.json());
        style.stretch_range = JSON.stringify(
            // metadata.range.map((num) => num.toFixed(0))
            metadata.range
        );
    }
    return style;
};

const data_source = async (layer_name, granularity, time) => {
    let style_params = new URLSearchParams(await get_style(
        layer_name, granularity, time,
    ));
    let url = `${tile_url}/singleband/${layer_name}/${granularity}/${time}/{z}/{x}/{y}.png?${style_params.toString()}`

    let _source = data_layer.getSource();
    if (_source !== null && _source.urls[0] === url) return _source;

    return new ol.source.XYZ({
        url: url,
        attributions: [
            // 'Projekt je sufinancirala Europska unija iz Europskog fonda za regionalni razvoj.',
            // 'Sadržaj materijala isključiva je odgovornost Sveučilišta u Zagrebu, Prirodoslovno-matematičkog fakulteta.',
        ],
    });
};

const data_layer = new ol.layer.Tile({
    source: null,
    opacity: .75,
});

const view = new ol.View({
    center: [cx, cy],
    zoom: 14,
    minZoom: 14,
    maxZoom: 20,
    extent: extent,
});

const marker = new ol.Feature({
    geometry: new ol.geom.Point([0, 0]),
});

const marker_src = document.querySelector('#marker-holder').src;

const marker_layer = new ol.layer.Vector({
    source: new ol.source.Vector({features: [marker]}),
    style: new ol.style.Style({
        image: new ol.style.Icon({
            anchor: [.5, .765],
            src: marker_src,
            scale: .75,
        }),
    }),
});

const attribution_control = new ol.control.Attribution({
    target: 'ol-attribution-container',
});

const zoom_control = new ol.control.Zoom({
    target: 'ol-zoom-container',
});

const scalebar = new ol.control.ScaleLine({
    target: 'ol-scale-container',
});

const map = new ol.Map({
    target: 'map',
    layers: [
        basemap_layer,
        data_layer,
        basemap_labels_layer,
        marker_layer,
    ],
    view: view,
    controls: [
        scalebar,
        attribution_control,
        zoom_control,
    ],
    interactions: ol.interaction.defaults({
        altShiftDragRotate: false,
        pinchRotate: false,
    }),
});

const legend_container = document.querySelector('#legend-container');

const build_colormap = (colormap, force_ints=false) => {
    legend_container.innerHTML = '';
    let ints = colormap.colormap
        .every((item, i) => Number.isInteger(item.value));
    colormap.colormap.reverse();
    colormap.colormap.forEach((item, i) => {
        let color = document.createElement('div');
        let value = document.createElement('div');
        color.style.background = `rgba(${item.rgba})`;
        color.className = 'legend-color';
        if (ints || force_ints) {
            value.innerHTML = item.value.toFixed(0);
        } else {
            value.innerHTML = item.value.toFixed(2);
        }
        value.className = 'legend-value';
        legend_container.appendChild(value);
        legend_container.appendChild(color);
    });
};

const get_colormap = async (layer_name, granularity, time) => {
    style_params = new URLSearchParams(await get_style(
        layer_name, granularity, time,
    ));
    style_params.append('num_values', 11);
    colormap_url = `${tile_url}/colormap?${style_params.toString()}`;
    let force_ints = layer_styles[layer_name] === undefined;
    let colormap = await fetch(colormap_url)
        .then(response => response.json());
    build_colormap(colormap, force_ints);
};


const view_layer = async (layer_name, granularity, time) => {
    document.querySelectorAll('.layer-selected').forEach((el) => {
        el.style.display = 'none';
    });
    document.querySelectorAll('.layer-time-selector-wrapper').forEach((el) => {
        el.style.display = 'none';
    });
    document.querySelectorAll('.layer-info-wrapper').forEach((el) => {
        el.style.display = 'none';
    });
    data_layer.setSource(await data_source(layer_name, granularity, time));
    let layer_selector = document.querySelector('#layer-selector-'+layer_name);
    let selected_indicator = layer_selector.querySelector('.layer-selected');
    selected_indicator.style.display = 'block';
    let layer_time_selector = layer_selector.parentNode.querySelector('.layer-time-selector-wrapper');
    if (layer_time_selector !== null) {
        let year = time.slice(0, 4);
        let season = time.slice(4);
        layer_time_selector.style.display = 'block';
        layer_time_selector.querySelectorAll('.layer-year-selector input').forEach((item, i) => {
            if (item.value === year) item.checked = true;
        });
        layer_time_selector.querySelectorAll('.layer-season-selector input').forEach((item, i) => {
            if ([granularity, season].includes(item.value)) item.checked = true;
        });
    }
    let layer_info = layer_selector.parentNode.querySelector('.layer-info-wrapper');
    if (layer_info !== null) {
        layer_info.style.display = 'block';
    }
    get_colormap(layer_name, granularity, time);
};

window.layer_state = {
    layer_name: null,
    granularity: null,
    time: null,
};

const multichoice_layers = [
    'LST',
    'NDVI',
];

window.chart_state = {
    chart: null,
    lonlat: null,
};

const layer_chart_colors = {
    'LST': '#f39200',
    'NDVI': '#4b9536',
};

const season_translate = {
    undefined: 'godišnje',
    winter: 'zima',
    spring: 'proljeće',
    autumn: 'jesen',
    summer: 'ljeto',
};

const chart_ctx = document.getElementById('chart');
const chart_container = document.querySelector('.chart-container');

const update_timeseries_chart = async () => {
    if (chart_state.chart !== null) {
        chart_state.chart.destroy();
        chart_container.style.display = 'none';
    }
    marker.setGeometry(null);

    switch (true) {
        case multichoice_layers.indexOf(layer_state.layer_name) === -1:
            return;
        case chart_state.lonlat === null:
            return;
    }

    let [lon, lat] = chart_state.lonlat;
    let coords = ol.proj.fromLonLat(chart_state.lonlat);
    marker.setGeometry(new ol.geom.Point(coords));

    let request_url = `${timeseries_url}/${layer_state.granularity}/${layer_state.layer_name}/${lon}/${lat}`;

    let period = undefined;

    if (layer_state.granularity !== 'yearly') {
        period = layer_state.time.slice(4);
        request_url += '?period=' + period;
    }

    let data = await fetch(
        request_url,
    ).then(resp => resp.json());

    if (data.data.every((item) => item.data === null)) {
        return;
    }

    view.animate({
        center: coords,
        duration: 500,
        zoom: 17,
    });

    chart_container.style.display = 'block';
    chart_state.chart = new Chart(chart_ctx, {
        type: 'line',
        data: {
            datasets: [{
                // label: `${layer_state.layer_name} ${layer_state.granularity}: ${lon.toFixed(3)}°E ${lat.toFixed(3)}°N`,
                label: `${layer_state.layer_name}`,
                data: data.data,
            }]
        },
        options: {
            parsing: {
                xAxisKey: 'year',
                yAxisKey: 'data',
            },
            scales: {
                y: {
                    ticks: {
                        color: '#544F4F'
                    },
                },
                x: {
                    ticks: {
                        color: '#544F4F'
                    },
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: `${layer_state.layer_name} ${season_translate[period]}: ${lon.toFixed(3)}°E ${lat.toFixed(3)}°N`,
                    color: '#544F4F',
                },
            },
            maintainAspectRatio: false,
            responsive: true,
            // global styling, ist this a good idea?
            pointBorderColor: '#544F4F',
            pointBorderWidth: 2,
            pointRadius: 5,
            pointHitRadius: 24,
            backgroundColor: layer_chart_colors[layer_state.layer_name],
            borderColor: layer_chart_colors[layer_state.layer_name],
            tension: .2,
        },
    });
};

document.querySelector('#chart-remove').onclick = () => {
    chart_state.lonlat = null;
    state2hash();
};

const hash_handler = () => {
    let hash_query = new URLSearchParams(window.location.hash.slice(1));
    if (hash_query.has('layer')) {
        let [
            layer_name,
            granularity,
            time,
        ] = hash_query.get('layer').split('-');
        if (layer_state.layer_name === null) layer_state.layer_name = layer_name;
        if (layer_state.granularity === null) layer_state.granularity = granularity;
        if (layer_state.time === null) layer_state.time = time;
        view_layer(layer_name, granularity, time);
    };
    if (hash_query.has('lon') && hash_query.has('lat')) {
        let lon = parseFloat(hash_query.get('lon'));
        let lat = parseFloat(hash_query.get('lat'));
        if (chart_state.lonlat === null) {
            chart_state.lonlat = [
                lon,
                lat,
            ];
        } else if (
            chart_state.lonlat[0] !== lon ||
            chart_state.lonlat[1] !== lat
        ) {
            chart_state.lonlat = [
                lon,
                lat,
            ];
        }
    }
    update_timeseries_chart();
};

// RUN ON PAGE LOAD
hash_handler();
window.addEventListener('hashchange', hash_handler);
if (window.location.hash === '') window.location.hash = '#layer=LST-seasonal-2013summer';

const state2hash = () => {
    let hash = `#layer=${layer_state.layer_name}-${layer_state.granularity}-${layer_state.time}`;
    if (chart_state.lonlat !== null) {
        let [lon, lat] = chart_state.lonlat;
        hash += `&lon=${lon}&lat=${lat}`;
    }
    window.location.hash = hash;
};

const layer_selector_click = (item) => {
    let layer_name = item.getAttribute('data-layer-name');
    if (layer_name === layer_state.layer_name) return;
    if (multichoice_layers.includes(layer_name)) {
        if (!multichoice_layers.includes(layer_state.layer_name)) {
            let year = item.parentNode.querySelector('.layer-year-selector input:checked').value;
            let season = item.parentNode.querySelector('.layer-season-selector input:checked').value;
            if (season === 'yearly') {
                layer_state.granularity = season;
                layer_state.time = year;
            } else {
                layer_state.granularity = 'seasonal';
                layer_state.time = `${year}${season}`;
            }
        }
    } else {
        layer_state.granularity = 'decadal';
        layer_state.time = '20012010';
    }
    layer_state.layer_name = layer_name;
    state2hash();
};

document.querySelectorAll('.layer-selector').forEach((item, i) => {
    item.onclick = () => layer_selector_click(item);
});

const year_selector_click = (item) => {
    layer_state.time = item.value + layer_state.time.slice(4);
    state2hash();
}

document.querySelectorAll('.layer-year-selector input').forEach((item, i) => {
    item.onclick = () => year_selector_click(item);
});

const season_selector_click = (item) => {
    let season = item.value;
    if (season === 'yearly') {
        layer_state.granularity = season;
        layer_state.time = layer_state.time.slice(0, 4);
    } else {
        layer_state.granularity = 'seasonal';
        layer_state.time = layer_state.time.slice(0, 4) + season;
    }
    state2hash();
}

document.querySelectorAll('.layer-season-selector input').forEach((item, i) => {
    item.onclick = () => season_selector_click(item);
});

const opacitySlider = document.getElementById('opacity-range');

opacitySlider.oninput = function() {
    data_layer.setOpacity(this.value / 100);
    this.parentNode.title = `opacity: ${this.value}%`;
}
data_layer.setOpacity(opacitySlider.value / 100);

const sidebar = document.querySelector('.sidebar');
const sidebar_show = document.querySelector('#sidebar-show');
const map_container = document.querySelector('.map');
const sidebar_remove = document.querySelector('#sidebar-remove');
const mo_logo = document.querySelector('.logo-mo');

let sidebar_shown = true;

const hide_sidebar = () => {
    // sidebar.style.display = 'none';
    sidebar.style['margin-right'] = '-100%';
    map_container.style.width = '100%';
    map.updateSize();
    sidebar_show.style.display = 'block';
    sidebar_remove.style.display = 'none';
    if (!mobile()) {
        mo_logo.style.right = '10px';
        // mo_logo.style.pointerEvents = 'none';
    }
    sidebar_shown = false;
};

const show_sidebar = () => {
    // sidebar.style.display = 'grid';
    sidebar.style.margin = '0px';
    setTimeout(() => {
        map_container.style.width = 'calc(100% - 340px)';
        map.updateSize();
    }, 500);
    sidebar_show.style.display = 'none';
    sidebar_remove.style.display = 'block';
    if (!mobile()) {
        mo_logo.style.right = '350px';
        // mo_logo.style.pointerEvents = 'auto';
    }
    sidebar_shown = true;
};

sidebar_remove.onclick = hide_sidebar;
sidebar_show.onclick = show_sidebar;

if (mobile()) {
    hide_sidebar();
}

const map_click_handler = (evt) => {
    let coords = evt.coordinate;
    let lonlat = ol.proj.toLonLat(coords)
    .map(
        (crd) => parseFloat(crd.toFixed(6)),
    );
    chart_state.lonlat = lonlat;
    state2hash();
    if (mobile()) {
        hide_sidebar();
    }
};

map.on('click', map_click_handler);

window.onresize = () => {
    switch (true) {
        case !mobile() && sidebar_shown:
            mo_logo.style.right = '350px';
            break;
        default:
            mo_logo.style.right = '10px';
    }
};
